import React from 'react'
import clsx from 'clsx'
import { useAppDispatch, useAppSelector } from '../../../../../hooks/redux'
import {
  Messages2,
  Sms,
  MessageText,
  // AddCircle,
  ArrowDown2
} from 'iconsax-react'

import SwitchV2 from '../../../../atoms/SwitchV2'
import ButtonMenu from '../../../../molecules/ButtonMenu2'

import {
  TYPES,
  getNameFromType,
  selectChatBox,
  togglePrivate,
  // startTaskCreate,
  changeType,
  getTypeFromName
} from '../../../../../slices/chatBoxSlice'
import { useQueueState } from '../../../../../providers/QueueStateProvider'
import { useChatEditState } from '../../../../../providers/ChatEditStateProvider'
import { useBreakpoint } from '../../../../../providers/BreakpointProvider'
// import useAccess, { PERMS } from '../../../../../hooks/useAccess'
import useStyles from './styles'

const getIconFromType = type => {
  switch (type) {
    case TYPES.LIVE:
      return Messages2
    case TYPES.EMAIL:
      return Sms
    case TYPES.SMS:
    default:
      return MessageText
  }
}

const Controls = () => {
  const dispatch = useAppDispatch()
  const { values } = useAppSelector(selectChatBox)
  const { isSmall } = useBreakpoint()

  const { conversation } = useQueueState()
  const { end: endEdit } = useChatEditState()

  const classes = useStyles()

  const Icon = React.useMemo(() => getIconFromType(values.type), [values.type])

  const options = React.useMemo(() => {
    return Object.values(TYPES).map(type => {
      const Icon = getIconFromType(type)

      return {
        name: getNameFromType(type),
        Icon: props => <Icon size='16' color='#404040' {...props} />
      }
    })
  }, [])

  // const handleCreateTaskClick = React.useCallback(() => {
  //   if (canCreateTask) {
  //     dispatch(startTaskCreate(TYPES.TASK))
  //   }
  // }, [canCreateTask, dispatch])

  const handleSelect = React.useCallback(
    val => {
      const type = getTypeFromName(val)
      dispatch(changeType(type))
    },
    [dispatch]
  )

  return (
    <div className={clsx(classes.root, classes.flexArea)}>
      <div className={classes.flexArea}>
        <ButtonMenu
          options={options}
          onSelect={handleSelect}
          className={clsx(
            classes.buttonBase,
            classes.dropdown,
            values.isPrivate && classes.disabled
          )}
          disabled={values.isPrivate}
          menuProps={{
            anchorOrigin: { horizontal: 'left', vertical: -4 },
            transformOrigin: { horizontal: 'left', vertical: 'bottom' },
            autoFocus: false
          }}
          classes={{
            paper: classes.menuPaper,
            list: classes.menuList,
            item: classes.menuItem,
            icon: classes.menuIcon
          }}
        >
          <Icon size='16' className='icon' style={{ flexShrink: 0 }} />
          {getNameFromType(values.type)}
          <ArrowDown2 size='16' variant='Bold' className='arrow' />
        </ButtonMenu>

        {/* <div
          onClick={handleCreateTaskClick}
          className={clsx(
            classes.buttonBase,
            classes.button,
            !canCreateTask && classes.disabled
          )}
        >
          <AddCircle size='16' color='#404040' className='icon' />
          {isSmall ? 'Task' : 'Create Task'}
        </div> */}
      </div>

      <div className={classes.flexArea}>
        <div className={classes.label}>
          {isSmall ? 'Private' : 'Private Note'}
        </div>

        <SwitchV2
          checked={values.isPrivate}
          onChange={() => {
            if (!conversation?.closed) {
              dispatch(togglePrivate())
            }
            endEdit()
          }}
          classes={{ root: classes.switch }}
        />
      </div>
    </div>
  )
}

export default Controls
